import { render } from "./BillingSuccess.vue?vue&type=template&id=08260348&scoped=true"
import script from "./BillingSuccess.vue?vue&type=script&lang=js"
export * from "./BillingSuccess.vue?vue&type=script&lang=js"

import "./BillingSuccess.vue?vue&type=style&index=0&id=08260348&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08260348"]])

export default __exports__